import React, { useCallback, useContext } from 'react';
import { convertFromPopperPlacement } from '@wix/da-ds/pkg/popper/helpers';
import PositionOnlyPopperPopover from '@wix/da-ds/pkg/popper/presets/PositionOnlyPopperPopover';
import { setRefs } from '../../utils/refHelpers';
import { DropdownStateContext } from '../DropdownStateManager';
import { PopperDropdownContext } from './PopperDropdownContext';
var PopperDropdownContent = React.forwardRef(function (_a, ref) {
    var usePortal = _a.usePortal, _b = _a.placement, popperPlacement = _b === void 0 ? 'bottom-end' : _b, offsetModifier = _a.offsetModifier, allowFlip = _a.allowFlip, children = _a.children, role = _a.role, className = _a.className, popperClassName = _a.popperClassName, referenceElement = _a.referenceElement, ariaLabel = _a["aria-label"];
    var _c = useContext(DropdownStateContext), isOpen = _c.isOpen, setMenuRef = _c.setMenuRef, closeDropdown = _c.closeDropdown;
    var toggleElement = useContext(PopperDropdownContext).toggleElement;
    var _d = convertFromPopperPlacement(popperPlacement), placement = _d.placement, secondaryPlacement = _d.secondaryPlacement;
    var onKeyDown = useCallback(function (e) {
        switch (e.key) {
            case 'Escape':
                closeDropdown();
                break;
            default:
                break;
        }
    }, [closeDropdown]);
    return (React.createElement(PositionOnlyPopperPopover, { isVisible: isOpen, usePortal: usePortal, referenceElement: referenceElement !== null && referenceElement !== void 0 ? referenceElement : toggleElement, popoverContent: children, placement: placement, secondaryPlacement: secondaryPlacement, offsetModifier: offsetModifier, allowFlip: allowFlip, innerRef: function (node) { return setRefs([setMenuRef, ref], node); }, className: className, wrapperClassName: popperClassName, onKeyDown: onKeyDown, role: role, "aria-label": ariaLabel }));
});
PopperDropdownContent.displayName = 'PopperDropdownContent';
export default PopperDropdownContent;
//# sourceMappingURL=PopperDropdownContent.js.map